const getBounds = (el) => el.getBoundingClientRect();

export default getBounds;